import moment from 'moment';
import { uniqBy } from 'lodash';
import { getEarliestBeginDate, getLatestEndDate } from 'lib/components/Timeline/Timeline.helpers';
import { getSelectedItems } from 'common/state.helper';
import { workOrderQuery } from '../../ReportsAPI';
import { getId } from 'common/data.utils';
import { Logger } from 'common/logger';

export const getEndTime = (startTime, endTime) => {
    // TODO: return vs release time? returntime can be negative
    let end;
    if (endTime) {
        end = moment(endTime).valueOf();
    } else {
        end = moment(startTime)
            .endOf('minute')
            .valueOf();
    }
    return end;
};

export const createListItem = (item, date, label, keyIsWorkOrder = false, entityKeyToNameMap) => {
    const startTime = moment(label === 'R' ? item.release_time : item.start_time).valueOf();
    const endTime = getEndTime(startTime, label === 'R' ? item.return_time : item.end_time);
    const turbineKey = getId(item);
    const earliest = getEarliestBeginDate(date);
    const latest = getLatestEndDate(date);
    const workOrder = item.woc_nr || item.awp_nr;

    return {
        turbineData: { ...item, turbineKey },
        key: keyIsWorkOrder ? workOrder : entityKeyToNameMap[turbineKey],
        type: label, // VisitorLog is always H & ReleaseOfPlant is always R
        beginDate: startTime < earliest ? earliest : startTime,
        endDate: endTime > latest ? latest : endTime,
    };
};

export const createUniqueArrayByKey = (array) => uniqBy(array, 'key');

export const createReleaseByTurbineID = (item, date, entityKeyToNameMap) =>
    createListItem(item, date, 'R', false, entityKeyToNameMap);

export const createReleaseByWorkOrderID = (item, date) => createListItem(item, date, 'R', true);

export const createVisitorByTurbineID = (item, date, entityKeyToNameMap) =>
    createListItem(item, date, 'H', false, entityKeyToNameMap);

export const createVisitorByWorkOrderID = (item, date) => createListItem(item, date, 'H', true);

export const prepareData = async (state, query, returnKey, normalizer) => {
    const { selectedDate, selectedParkId } = getSelectedItems(state);
    const turbine = state.menuBar.selectedTurbineKey;

    try {
        const response = await query(selectedDate, selectedParkId, turbine);
        return createUniqueArrayByKey(response.data.filter((data) => !!data[returnKey] && data.woc_nr)).map((item) =>
            normalizer(item, selectedDate)
        );
    } catch {
        return [];
    }
};

export const applyWorkOrders = async (state, maintenanceData) => {
    const { selectedDate, selectedParkId } = getSelectedItems(state);
    const turbine = state.menuBar.selectedTurbineKey;
    const earliestDate = getEarliestBeginDate(selectedDate);
    const latestDate = getLatestEndDate(selectedDate);
    try {
        const response = await workOrderQuery(selectedDate, selectedParkId, turbine);
        return maintenanceData.map((item) => {
            const newItem = { ...item };
            if (newItem.beginDate < earliestDate) {
                newItem.beginDate = earliestDate;
            }
            if (newItem.endDate > latestDate) {
                newItem.endDate = latestDate;
            }
            response.data.forEach((workOrder) => {
                if (workOrder.work_order_id === newItem.key && newItem.turbineData) {
                    newItem.turbineData.order = workOrder.description;
                }
            });
            return newItem;
        });
    } catch (e) {
        Logger.debug('Error in applyWorkOrders, returning only maintenanceData', e);
        return maintenanceData;
    }
};
